<template>
  <div class="row app-wrapper">
    <sidebar :route="currentRoute" :class="sidebarClassName"></sidebar>
    <section class="app-content columns" :class="contentClassName">
      <router-view></router-view>
      <command-bar />
    </section>
    <TheSIPEndpoint />
    <MissedCallMenu />
    <TheRelaySIPEndpoint />
    <div class="flex row hidden-iframe">
      <div class="columns medium-12">
        <pulse-loader :loading="true" :color="color"></pulse-loader>
        <iframe
          :key="iframeKey"
          :src="generateDigitalSign"
          allow="clipboard-read; clipboard-write"
          sandbox="allow-scripts allow-downloads allow-forms allow-modals allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-top-navigation allow-top-navigation-by-user-activation"
          style="height: calc(100vh - 66px);border: none;"
          width="100%"
          height="80%"
        ></iframe>
      </div>
    </div>
    <!-- Hard-disable account/inbox limit modal to prevent unintended create-account prompt -->
  </div>
</template>

<script>
import Sidebar from '../../components/layout/Sidebar';
import TheSIPEndpoint from '../../components/TheSIPEndpoint/TheSIPEndpoint';
import MissedCallMenu from '../../components/MissedCallMenu';
import TheRelaySIPEndpoint from '../../components/TheSIPEndpoint/TheRelaySIPEndpoint';
import { mapGetters } from 'vuex';
import CommandBar from './commands/commandbar.vue';

import { minLength } from 'vuelidate/lib/validators';

export default {
  components: {
    Sidebar,
    CommandBar,
    MissedCallMenu,
    TheSIPEndpoint,
    TheRelaySIPEndpoint,
  },
  validations: {
    selectedAgents: {
      isEmpty() {
        return !!this.selectedAgents.length;
      },
    },
    selectedInboxes: {
      isEmpty() {
        return !!this.selectedInboxes.length;
      },
    },
  },
  data() {
    return {
      isSidebarOpen: false,
      isOnDesktop: true,
      agent_list: {},
      inbox_list: {},
      selectedAgents: [],
      selectedInboxes: [],
      account_user: '',
      user_limits: '',
      user_role: '',
      closePopup: false,
      color: 'black',
      signDocsLink: '',
      iframeKey: 1,
      activeUser: '',
    };
  },
  computed: {
    ...mapGetters({
      all_limits: 'accounts/getAllLimits',
      dashboardAction: 'dashboard/getDashboardAction',
      currentUser: 'getCurrentUser',
    }),

    generateDigitalSign() {
      if (!window.chatwootConfig.signDocsUrl || window.chatwootConfig.signDocsUrl === 'undefined') {
        this.signDocsLink = '';
        return '';
      }
      const encodedEmail = encodeURIComponent(this.currentUser?.email);
      this.signDocsLink = `${window.chatwootConfig.signDocsUrl}/#/?parent=conversate&name=${this.currentUser?.name}&reference_id=${this.currentUser?.account_id}&email=${encodedEmail}&digest=${encodedEmail}`;
      return this.signDocsLink;
    },
    currentRoute() {
      return ' ';
    },
    sidebarClassName() {
      if (this.isOnDesktop) {
        return '';
      }
      if (this.isSidebarOpen) {
        return 'off-canvas is-open ';
      }
      return 'off-canvas position-left is-transition-push is-closed';
    },
    contentClassName() {
      if (this.isOnDesktop) {
        return '';
      }
      if (this.isSidebarOpen) {
        return 'off-canvas-content is-open-left has-transition-push has-position-left';
      }
      return 'off-canvas-content';
    },
    inboxSubtract() {
      let inbox = this.user_limits;
      return inbox.current_inbox_count - inbox.total_inbox_limit;
    },
    agentSubtract() {
      let agent = this.user_limits;
      return agent.current_agent_count - agent.total_agent_limit;
    },
  },
  watch: {
    dashboardAction: async function(value) {
      if (value) {
        if (value === 'CLOSE_SIDEBAR') {
          this.isSidebarOpen = false;
        }

        this.$store.commit('dashboard/SET_DASHBOARD_ACTION', null);
      }
    },
    currentUser(newValue, oldValue) {
      // Handle changes to currentUser here
      this.activeUser = newValue;
    },
  },
  mounted() {
    this.$store.dispatch('setCurrentAccountId', this.$route.params.accountId);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    bus.$on('sidemenu_icon_click', () => {
      this.isSidebarOpen = !this.isSidebarOpen;
    });
    // The account-limit modal was disabled; avoid fetching limit data that
    // previously triggered the modal and extra API calls/404s in some envs.
    this.$store.dispatch('inboxes/get');
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isOnDesktop = window.innerWidth > 1200;
    },
    // Delete Function
    showLimitModel() {
      return this.agentSubtract > 0 || this.inboxSubtract > 0;
    },
    closeDeletePopup() {
      return !(
        this.selectedAgents.length < this.agentSubtract ||
        this.selectedInboxes.length < this.inboxSubtract
      );
    },
    confirmDeletion() {
      if (
        this.selectedAgents.length < this.agentSubtract ||
        this.selectedInboxes.length < this.inboxSubtract
      ) {
        bus.$emit('newToastMessage', 'Please select agent and inboxes.');
      } else {
        var agent_ids = this.selectedAgents.map(agent => agent.id);
        var inbox_ids = this.selectedInboxes.map(inbox => inbox.id);
        this.deleteExtraLimits(agent_ids, inbox_ids);
      }
    },
    async deleteExtraLimits(agent_ids, inbox_ids) {
      let data = { agent_ids: agent_ids, inbox_ids: inbox_ids };
      try {
        await this.$store
          .dispatch('accounts/removeExtraLimit', data)
          .then(() => {
            bus.$emit('newToastMessage', 'updated successfully.');
            window.location.reload();
          });
      } catch (error) {
        throw error;
      }
    },
    async getLimitDetails() {
      await this.$store
        .dispatch('accounts/getExtraLimit', this.$route.params.accountId)
        .then(response => {
          this.agent_list = response.agents;
          this.inbox_list = response.inboxes;
          this.account_user = response.account_user;
          this.user_limits = response.limits;
          this.user_role = response.user_role;
        });
    },
  },
};
</script>
<style lang="scss">
@import '~dashboard/assets/scss/variables.scss';
@import '~dashboard/assets/scss/mixins.scss';

.account-selector--modal .modal-container {
  width: 90rem !important;
  height: 38rem !important;
}
.mt-2 {
  margin-top: 2rem;
}

.multiselect__content-wrapper {
  max-height: 600px !important;
}
.account-selector--modal-agent {
  .modal-container {
    width: 55rem !important;
    height: 12rem !important;
  }
}
.hidden-iframe {
  display: none;
}
.account-selector--modal
  .modal-container
  .tree-level1
  .tree-level2
  .treeselectClass
  .vue-treeselect__control
  .vue-treeselect__value-container
  .vue-treeselect__input-container
  .vue-treeselect__input {
  border: none !important;
}
</style>
